import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProfileRoutingModule } from './profile-routing.module';
import { ProfilePasswordComponent } from './profile-password/profile-password.component';
import { ProfileListComponent } from './profile-list/profile-list.component';
import { ProfileListDetailComponent } from './profile-list-detail/profile-list-detail.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DropdownModule} from 'primeng/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CoreModule} from '../../core/core.module';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        ProfileRoutingModule,
        NgbModule,
        ModalModule.forRoot(),
        CoreModule,
        TranslateModule,
    ],
  declarations: [
    ProfilePasswordComponent,
    ProfileListComponent,
    ProfileListDetailComponent
  ]
})
export class ProfileModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile.module.ts